import axios from 'axios';

export const footer = async () => {
  const response = await axios.get('general-components/footer');

  return response?.data;
};
